import { eventListenerOrTimeout } from '../../events/event-listener-or-timeout';
import { getAnimationEndEventName } from '../get-animation-end-event-name';

const animationEndEventName = getAnimationEndEventName();

export function addAnimationEndListener(
	element: Element,
	callback: () => void,
	fallbackDuration = 0,
	remove = true
): void {
	eventListenerOrTimeout(
		animationEndEventName,
		element,
		callback,
		fallbackDuration,
		remove
	);
}
